import { appConfig } from '@/config'

export default {
    data() {
        return {
            pagination: {},
            paginationSettings: {
                paginationNext: null,
                paginationPrev: null,
                paginationCurrentPage: null,
                paginationCurrentRows: null,
                paginationPending: false,
                currentUrl: null
            }
        }
    },
    computed: {
        footerProps() {
            return {
                itemsPerPageOptions: appConfig.common.rowsPerPageItems
            }
        },
        savedPagination() {
            return this.$store.state.common.savedPagination
        }
    },
    methods: {
        paginate() {
            let paginationURL = `?limit=${this.pagination.itemsPerPage}`

            if (this.paginationSettings.paginationCurrentRows && (this.paginationSettings.paginationCurrentRows !== this.pagination.itemsPerPage)) {
                this.paginationSettings.paginationCurrentPage = this.pagination.page
                this.paginationSettings.paginationCurrentRows = this.pagination.itemsPerPage
                this.paginationSettings.currentUrl = paginationURL

                return paginationURL
            }

            if (this.paginationSettings.paginationCurrentPage) {
                if (this.pagination.page > this.paginationSettings.paginationCurrentPage) {
                    paginationURL = this.paginationSettings.paginationNext
                    this.paginationSettings.currentUrl = paginationURL
                } else if (this.pagination.page < this.paginationSettings.paginationCurrentPage) {
                    paginationURL = this.paginationSettings.paginationPrev
                    this.paginationSettings.currentUrl = paginationURL
                } else if (this.pagination.page !== 1) {
                    paginationURL = this.paginationSettings.currentUrl
                }
            }

            this.paginationSettings.paginationCurrentPage = this.pagination.page
            this.paginationSettings.paginationCurrentRows = this.pagination.itemsPerPage
            this.paginationSettings.paginationPending = true

            return paginationURL
        },
        handlePaginationResponse({ data }) {
            this.pagination.itemsLength = data.count
            this.pagination.page = data.current
            this.paginationSettings.paginationCurrentPage = data.current
            this.paginationSettings.paginationNext = data.next
            this.paginationSettings.paginationPrev = data.previous
            this.$store.dispatch('clearPagination')
        },
        clearPaginationPending() {
            this.paginationSettings.paginationPending = false
        },
        savePagination(moduleName) {
            this.$store.dispatch('savePagination', {
                moduleName: moduleName,
                pagination: this.pagination,
                settings: this.paginationSettings
            })
        },
        evaluateSavedPagination(moduleName) {
            if (this.savedPagination.pagination && this.savedPagination.moduleName === moduleName) {
                this.pagination = this.savedPagination.pagination
                this.paginationSettings = this.savedPagination.settings
            }
        },
        resetPagination() {
            this.pagination = {
                page:1,
                itemsPerPage: this.pagination.itemsPerPage,
                pageStart: 0,
                pageStop: 0,
                pageCount: 0,
                itemsLength: 0
            }
            this.paginationSettings = {
                paginationNext: null,
                paginationPrev: null,
                paginationCurrentPage: null,
                paginationCurrentRows: null,
                paginationPending: false,
                currentUrl: null
            }
        }
    }
}
